export default {
  // Navigation
  nav_home: 'Beranda',
  nav_dashboard: 'Dasbor',
  nav_orders: 'Pesanan',
  nav_wallet: 'Dompet',
  nav_analytics: 'Analitik',
  nav_referral: 'Referral',
  nav_account: 'Akun',
  nav_notifications: 'Notifikasi',
  nav_logout: 'Keluar',
  nav_login: 'Masuk',
  nav_signup: 'Daftar',
  nav_deposit_requests: 'Permintaan Deposit',
  nav_withdraw_requests: 'Permintaan Penarikan',
  nav_support_ticket: 'Tiket Dukungan',
  nav_system_logs: 'Log Sistem',
  nav_announcements: 'Pengumuman',
  nav_activity_logs: 'Log Aktivitas',
  nav_settings: 'Pengaturan',
  nav_section_main: 'Utama',
  nav_user_active: 'Aktif sekarang',
  nav_more: 'Lainya',
  nav_logout_confirm: 'Apakah Anda yakin ingin keluar?',
  nav_language: 'Bahasa',

  // Dashboard
  dashboard_welcome: 'Selamat datang kembali',
  dashboard_total_earnings: 'Total Penghasilan',
  dashboard_pending_orders: 'Pesanan Tertunda',
  dashboard_completed_orders: 'Pesanan Selesai',
  dashboard_commission_rate: 'Tingkat Komisi',
  dashboard_quick_actions: 'Tindakan Cepat',
  dashboard_recent_orders: 'Pesanan Terbaru',
  dashboard_recent_activity: 'Aktivitas Terbaru',
  dashboard_wallet_balance: 'Saldo Dompet',
  dashboard_deposit: 'Deposit',
  dashboard_withdraw: 'Tarik',
  dashboard_view_all: 'Lihat Semua',
  greeting_morning: 'Selamat Pagi',
  greeting_afternoon: 'Selamat Siang',
  greeting_evening: 'Selamat Malam',
  dashboard_greeting_desc: 'Lacak penghasilan Anda, selesaikan pesanan, dan kelola akun Anda di satu tempat. Perjalanan sukses Anda berlanjut di sini!',

  // Dashboard Stats
  stats_available_balance: 'Saldo Tersedia',
  stats_total_withdrawn: 'Total Ditarik',
  stats_total_deposit: 'Total Deposit',
  stats_pending_orders: 'Pesanan Tertunda',
  stats_orders_suffix: ' pesanan',
  stats_task_earnings: 'Penghasilan Tugas',
  stats_lifetime_earning: 'Penghasilan Seumur Hidup',

  // Orders
  orders_title: 'Pesanan Saya',
  orders_all: 'Semua Pesanan',
  orders_pending: 'Tertunda',
  orders_completed: 'Selesai',
  orders_cancelled: 'Dibatalkan',
  orders_order_id: 'ID Pesanan',
  orders_platform: 'Platform',
  orders_amount: 'Jumlah',
  orders_commission: 'Komisi',
  orders_status: 'Status',
  orders_date: 'Tanggal',
  orders_no_orders: 'Pesanan tidak ditemukan',

  // Wallet
  wallet_title: 'Dompet Saya',
  wallet_available_balance: 'Saldo Tersedia',
  wallet_pending_balance: 'Saldo Tertunda',
  wallet_total_withdrawn: 'Total Ditarik',
  wallet_deposit_now: 'Deposit Sekarang',
  wallet_withdraw_now: 'Tarik Sekarang',
  wallet_transaction_history: 'Riwayat Transaksi',
  wallet_deposit_history: 'Riwayat Deposit',
  wallet_withdrawal_history: 'Riwayat Penarikan',
  wallet_deposit_desc: "Tambahkan uang ke dompet Anda باستخدام metode pembayaran yang tersedia.",
  wallet_no_deposits: "Tidak ada setoran ditemukan.",
  wallet_withdraw_history: "Riwayat penarikan",
  wallet_withdraw_desc: "Tarik uang dari dompet Anda.",
  wallet_no_withdrawals: "Tidak ada penarikan ditemukan.",
  wallet_no_withdrawals_desc: "Anda belum melakukan penarikan.",

  // Analytics
  analytics_title: 'Analitik',
  analytics_earnings_overview: 'Ikhtisar Penghasilan',
  analytics_platform_breakdown: 'Rincian Platform',
  analytics_performance_metrics: 'Metrik Performa',
  analytics_top_products: 'Produk Teratas',
  analytics_this_month: 'Bulan Ini',
  analytics_last_month: 'Bulan Lalu',
  analytics_total_revenue: 'Total Pendapatan',
  analytics_avg_order_value: 'Nilai Rata-rata Pesanan',

  // Referral
  referral_title: 'Program Referral',
  referral_your_code: 'Kode Referral Anda',
  referral_copy_code: 'Salin Kode',
  referral_share_link: 'Bagikan Tautan',
  referral_total_referrals: 'Total Referral',
  referral_active_referrals: 'Referral Aktif',
  referral_referral_earnings: 'Penghasilan Referral',
  referral_invite_friends: 'Undang Teman',

  // Account
  account_title: 'Pengaturan Akun',
  account_profile: 'Profil',
  account_security: 'Keamanan',
  account_notifications: 'Notifikasi',
  account_kyc: 'Verifikasi KYC',
  account_phone: 'Nomor Telepon',
  account_two_factor: 'Autentikasi Dua Faktor',
  account_save_changes: 'Simpan Perubahan',
  account_cancel: 'Batal',

  // Auth & Common
  auth_email: 'Email',
  auth_password: 'Kata Sandi',
  auth_confirm_password: 'Konfirmasi Kata Sandi',
  auth_forgot_password: 'Lupa Kata Sandi?',
  auth_remember_me: 'Ingat Saya',
  auth_login_button: 'Masuk',
  auth_signup_button: 'Daftar',
  auth_already_have_account: 'Sudah punya akun?',
  auth_dont_have_account: "Belum punya akun?",
  auth_reset_password: 'Atur Ulang Kata Sandi',
  auth_verify_email: 'Verifikasi Email',
  auth_live_platform: 'Platform Langsung',
  auth_security_verification: 'Verifikasi Keamanan',
  auth_captcha_refresh: 'Segarkan',
  auth_captcha_placeholder: 'Hasil',
  auth_captcha_error: 'Penjumlahan salah, silakan coba lagi',
  auth_branding_title: 'Ubah Promosi Menjadi',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Penghasilan Nyata',
  auth_branding_desc: 'Bergabunglah dengan ribuan promotor yang mendapatkan komisi harian dari merek e-commerce ternama di dunia.',
  auth_sign_in_to_account: 'Masuk ke akun {{system_name}} Anda',
  auth_email_placeholder: 'anda@contoh.com',
  auth_password_placeholder: 'Masukkan kata sandi Anda',
  auth_signing_in: 'Masuk...',
  auth_free_to_join: 'Gratis untuk Bergabung',
  auth_signup_branding_title: 'Mulai Menghasilkan',
  auth_signup_branding_highlight: 'Dari Hari Pertama',
  auth_signup_branding_desc: 'Tidak perlu pengalaman. Daftar dalam 2 menit dan mulai selesaikan tugas untuk merek e-commerce ternama.',
  auth_how_it_works: 'Cara kerja',
  auth_signup_desc: 'Bergabunglah dengan {{system_name}} dan mulai dapatkan komisi hari ini — gratis!',
  auth_step_1: 'Buat akun gratis Anda',
  auth_step_2: 'Telusuri dan terima tugas',
  auth_step_3: 'Selesaikan dan dapatkan komisi',
  auth_signup_step_1_title: 'Buat Akun',
  auth_signup_step_1_desc: 'Mulai perjalanan Anda',
  auth_signup_step_2_title: 'Selesaikan Tugas',
  auth_signup_step_2_desc: 'Dapatkan komisi harian',
  auth_signup_step_3_title: 'Tarik Dana',
  auth_signup_step_3_desc: 'Penarikan cepat dan aman',
  auth_benefit_1_title: 'Aman dan Terpercaya',
  auth_benefit_1_desc: 'Keamanan setingkat bank untuk penghasilan Anda',
  auth_benefit_2_title: 'Pembayaran Instan',
  auth_benefit_2_desc: 'Tarik penghasilan dalam waktu 24 jam',
  auth_benefit_3_title: 'Komunitas Global',
  auth_benefit_3_desc: 'Bergabunglah dengan 12.000+ promotor aktif',
  auth_benefit_4_title: 'Dukungan 24/7',
  auth_benefit_4_desc: 'Dapatkan bantuan kapan pun Anda butuhkan',
  auth_strength_weak: 'Lemah',
  auth_strength_fair: 'Cukup',
  auth_strength_good: 'Bagus',
  auth_strength_strong: 'Kuat',
  auth_password_strength: 'Kekuatan kata sandi: {{strength}}',
  auth_social_proof: 'Bergabunglah dengan {{count}}+ penghasil lainnya',
  auth_passwords_match: 'Kata sandi cocok',
  auth_creating_account: 'Membuat akun...',
  auth_phone_number: 'Nomor Telepon',
  auth_phone_optional: '(Opsional)',
  auth_phone_placeholder: 'Nomor telepon Anda',
  auth_full_name: 'Nama Lengkap',
  auth_full_name_placeholder: 'Budi Santoso',
  auth_password_min_chars: 'Minimal 8 karakter',
  auth_confirm_password_placeholder: 'Ulangi kata sandi Anda',
  auth_agree_to: 'Saya setuju dengan',
  auth_terms_of_service: 'Syarat Layanan',
  auth_privacy_policy: 'Kebijakan Privasi',
  auth_and: 'dan',
  auth_create_free_account: 'Buat Akun Gratis',

  common_loading: 'Memuat...',
  common_save: 'Simpan',
  common_cancel: 'Batal',
  common_delete: 'Hapus',
  common_edit: 'Ubah',
  common_view: 'Lihat',
  common_search: 'Cari',
  common_filter: 'Filter',
  common_export: 'Ekspor',
  common_import: 'Impor',
  common_submit: 'Kirim',
  common_close: 'Tutup',
  common_confirm: 'Konfirmasi',
  common_success: 'Berhasil',
  common_error: 'Kesalahan',
  common_warning: 'Peringatan',
  common_announcement: 'Pengumuman',

  val_full_name_required: 'Nama lengkap wajib diisi',
  val_email_required: 'Email wajib diisi',
  val_password_required: 'Kata sandi wajib diisi',
  val_password_min: 'Kata sandi minimal 8 karakter',
  val_passwords_dont_match: 'Kata sandi tidak cocok',
  val_agree_terms: 'Anda harus menyetujui syarat',
  val_conn_error: 'Kesalahan koneksi. Silakan coba lagi.',

  // Homepage
  home_hero_title: 'Dapatkan Komisi dari Platform E-Commerce Ternama',
  home_hero_subtitle: 'Bergabunglah dengan ribuan pengguna yang mendapatkan komisi harian dari Walmart, Alibaba, dan AliExpress',
  home_get_started: 'Mulai Sekarang',
  home_learn_more: 'Pelajari Lebih Lanjut',
  home_how_it_works: 'Cara Kerja',
  home_features: 'Fitur',
  home_why_choose_us: 'Mengapa Memilih Kami',
  home_features_title: 'Fitur Unggulan',
  home_features_subtitle: 'Semua yang Anda butuhkan untuk mulai menghasilkan secara online. Dibangun demi kesuksesan Anda.',
  home_commission_tiers: 'Tingkatan Komisi',
  home_testimonials: 'Apa Kata Pengguna Kami',
  home_faq: 'Pertanyaan Umum',
  home_cta_title: 'Siap untuk mulai menghasilkan?',
  home_cta_subtitle: 'Bergabunglah dengan komunitas kami hari ini dan mulai dapatkan komisi',
  home_trusted_partner: 'Platform Mitra Terpercaya',
  home_secure_platform: 'Platform Aman',
  home_instant_payouts: 'Pembayaran Instan',
  home_active_users: 'Pengguna Aktif',
  home_paid_out: 'Telah Dibayar',
  home_total_paid_out: 'Total Diterima',
  home_user_rating: 'Rating Pengguna',
  home_countries: 'Negara',
  home_commission_badge: 'Potensi Penghasilan',
  home_commission_title: 'Tingkat Komisi',
  home_commission_desc: 'Saldo yang lebih tinggi membuka tingkat komisi yang lebih baik. Setiap sesi memberikan tepat 25 pesanan — selesaikan hingga 4 sesi per hari untuk penghasilan maksimal.',
  home_tier_popular: 'Paling Populer',
  home_tier_commission_per_order: 'Komisi Per Pesanan',
  home_tier_earn_examples: 'Contoh Penghasilan:',
  home_tier_order: 'pesanan',
  home_tier_batch_earn: 'Penghasilan per batch 25 pesanan:',
  home_tier_daily_potential: 'Potensi Harian (4 batch × 25 pesanan)',
  home_tier_max_daily: 'Hingga 100 pesanan per hari',
  home_tier_benefit_1: '25 pesanan per batch',
  home_tier_benefit_2: 'Maksimal 4 batch per hari',
  home_tier_benefit_3: 'Kredit komisi instan',
  home_tier_above: 'Di atas',
  home_tier_no_tiers: 'Tingkatan komisi tidak ditemukan.',

  // Comparison Section
  home_compare_badge: 'Perbedaan',
  home_compare_title: 'Mengapa Kami Lebih Baik',
  home_compare_subtitle: 'Bandingkan platform kami dengan pekerjaan paruh waktu tradisional dan lihat mengapa ribuan orang memilih kami.',
  home_compare_feature: 'Fitur',
  home_compare_traditional: 'Pekerjaan Tradisional',
  home_compare_our_platform: 'Platform Kami',
  home_compare_f1: 'Fleksibilitas',
  home_compare_f1_trad: 'Jadwal tetap',
  home_compare_f1_our: 'Bekerja kapan saja, di mana saja',
  home_compare_f2: 'Pembayaran',
  home_compare_f2_trad: 'Bulanan atau dua mingguan',
  home_compare_f2_our: 'Instan / Hari yang sama',
  home_compare_f3: 'Persyaratan',
  home_compare_f3_trad: 'Pengalaman/CV/Wawancara',
  home_compare_f3_our: 'Tidak ada - Cukup ponsel pintar',
  home_compare_f4: 'Pertumbuhan',
  home_compare_f4_trad: 'Kenaikan tahunan tetap',
  home_compare_f4_our: 'Pertumbuhan berbasis tingkat tanpa batas',

  // Testimonials
  home_testi_badge: 'Kisah Sukses',
  home_testi_title: 'Dipercayai oleh Ribuan',
  home_testi_subtitle: 'Dengarkan dari komunitas promotor global kami yang telah mengubah pendapatan mereka.',
  home_testi_no_stories: 'Belum ada kisah sukses yang tersedia.',
  home_testi_total_earned: 'Total Dihasilkan',
  home_testi_time_period: 'Periode Waktu',
  home_testi_verified: 'Pengguna Terverifikasi',
  home_testi_avg_rating: 'Rating Rata-rata',
  home_testi_satisfaction_rate: 'Tingkat Kepuasan',
  home_testi_support_available: 'Dukungan Tersedia',

  // FAQ
  home_faq_badge: 'Dukungan',
  home_faq_title: 'Pertanyaan Umum',
  home_faq_subtitle: 'Semua yang perlu Anda ketahui tentang cara memulai dan menghasilkan.',
  home_faq_no_data: 'Pertanyaan tidak ditemukan.',

  // Trust Bar
  home_trust_badge: 'Kepercayaan Global',
  home_trust_title: 'Dipercaya oleh Merek Terkemuka',
  home_trust_desc: 'Kami bermitra dengan platform e-commerce terbesar di dunia untuk menyediakan layanan promosi terverifikasi.',

  // Feature Section
  feature_1_title: 'Pembayaran Instan',
  feature_1_desc: 'Dapatkan penghasilan Anda dikreditkan segera setelah pesanan selesai. Tarik kapan saja tanpa penundaan.',
  feature_1_detail_1: 'Kredit komisi real-time',
  feature_1_detail_2: 'Berbagai opsi penarikan',
  feature_1_detail_3: 'Tanpa ambang batas minimum',
  feature_2_title: 'Platform Aman',
  feature_2_desc: 'Enkripsi sekelas bank melindungi data dan penghasilan Anda. Dipercaya oleh ribuan pengguna di seluruh dunia.',
  feature_2_detail_1: 'Enkripsi SSL diaktifkan',
  feature_2_detail_2: 'Autentikasi dua faktor',
  feature_2_detail_3: 'Audit keamanan berkala',
  feature_2_detail_4: 'Privasi data terjamin',
  feature_3_title: 'Jam Fleksibel',
  feature_3_desc: 'Bekerja kapan pun Anda mau, di mana pun Anda berada. Selesaikan pesanan sesuai kecepatan Anda sendiri tanpa jadwal tetap.',
  feature_3_detail_1: 'Tanpa jam kerja tetap',
  feature_3_detail_2: 'Bekerja dari mana saja',
  feature_3_detail_3: 'Pilih kecepatan Anda sendiri',
  feature_3_detail_4: 'Ketersediaan akhir pekan',
  feature_4_title: 'Penghasilan Progresif',
  feature_4_desc: 'Buka tingkat komisi yang lebih tinggi seiring dengan banyaknya pesanan yang Anda selesaikan. Tingkatkan pendapatan Anda setiap naik tingkat.',
  feature_4_detail_1: 'Tingkat komisi berbasis level',
  feature_4_detail_2: 'Peningkatan tingkat otomatis',
  feature_4_detail_3: 'Penghargaan performa',
  feature_5_title: 'Platform Global',
  feature_5_desc: 'Bekerja dengan merek internasional dari mana saja di seluruh dunia. Termasuk dukungan berbagai mata uang.',
  feature_5_detail_1: 'Tersedia di seluruh dunia',
  feature_5_detail_2: 'Dukungan multi-mata uang',
  feature_5_detail_3: 'Metode pembayaran lokal',
  feature_6_title: 'Dukungan 24/7',
  feature_6_desc: 'Tim dukungan kami yang berdedikasi selalu siap membantu. Dapatkan bantuan melalui live chat, email, atau telepon.',
  feature_6_detail_1: 'Live chat tersedia',
  feature_6_detail_2: 'Dukungan email 24/7',
  feature_6_detail_3: 'Bantuan telepon',
  feature_6_detail_4: 'FAQ komprehensif',
  feature_7_title: 'Program Referral',
  feature_7_desc: 'Dapatkan penghasilan tambahan dengan mengundang teman. Dapatkan komisi seumur hidup dari penghasilan referral Anda.',
  feature_7_detail_1: 'Penghasilan referral seumur hidup',
  feature_7_detail_2: 'Referral tidak terbatas',
  feature_7_detail_3: 'Alat berbagi yang mudah',
  feature_7_detail_4: 'Insentif bonus',
  feature_8_title: 'Multi-Mata Uang',
  feature_8_desc: 'Dukungan untuk mata uang utama dan metode pembayaran. Pilih yang paling sesuai untuk Anda.',
  feature_8_detail_1: 'Dukungan USD, EUR, GBP',
  feature_8_detail_2: 'Transfer bank tersedia',
  feature_8_detail_3: 'Integrasi e-wallet',
  feature_8_detail_4: 'Opsi kripto segera hadir',
  feature_9_title: 'Notifikasi Instan',
  feature_9_desc: 'Tetap terperbarui dengan peringatan real-time untuk pesanan baru, penghasilan, dan aktivitas akun.',
  feature_9_detail_1: 'Notifikasi push',
  feature_9_detail_2: 'Peringatan email',
  feature_9_detail_3: 'Pembaruan SMS',
  feature_9_detail_4: 'Pesan dalam aplikasi',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Proses Sederhana',
  home_how_it_works_title: 'Cara Kerja',
  home_how_it_works_subtitle: 'Mulai menghasilkan dalam 4 langkah mudah. Tidak perlu pengalaman, cukup ikuti prosesnya dan lihat penghasilan Anda tumbuh.',
  home_cta_ready_title: 'Siap Memulai Perjalanan Anda?',
  home_cta_ready_desc: 'Bergabunglah dengan ribuan pengguna yang sudah menghasilkan setiap hari. Komisi pertama Anda hanya berjarak beberapa menit!',
  home_cta_avg_time: 'Waktu rata-rata untuk penghasilan pertama:',
  home_cta_15_mins: '15 menit',
  home_cta_new_users: 'Pengguna baru hari ini:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Kuota Terbatas Bulan Ini',
  home_cta_main_title: 'Mulai Cari Uang',
  home_cta_today: 'Hari Ini!',
  home_cta_main_desc: 'Bergabunglah dengan ribuan pengguna yang sudah mendapatkan komisi harian. Tanpa pengalaman, jam fleksibel, pembayaran instan. Kebebasan finansial Anda dimulai di sini.',
  home_cta_spots_remaining: 'Kuota Tersisa',
  home_cta_new_users_today: 'Pengguna Baru Hari Ini',
  home_cta_create_account: 'Buat Akun Gratis',
  home_cta_sign_in: 'Masuk',
  home_cta_secure: '100% Aman',
  home_cta_payouts: 'Pembayaran dalam 24-48 jam',
  home_cta_rating: 'Rating 4.9/5',
  home_cta_active_users: 'Pengguna Aktif',
  home_cta_total_paid: 'Total Dibayarkan',
  home_cta_orders_done: 'Tugas Selesai',
  home_cta_satisfaction: 'Kepuasan',
  home_cta_guarantee_title: 'Garansi Uang Kembali',
  home_cta_guarantee_desc: 'Tidak puas? Dapatkan deposit Anda kembali dalam 7 hari',

  // Footer Branding & Extras
  footer_brand_desc: 'Platform promosi e-commerce terkemuka di dunia. Bergabunglah dengan jaringan promotor global kami hari ini dan mulai dapatkan komisi dari merek-merek ternama.',
  footer_ssl_secure: 'SSL Aman',
  footer_aes_256: 'Enkripsi AES-256',
  footer_cookie_policy: 'Kebijakan Cookie',
  footer_disclaimer: 'Sanggahan',
  footer_all_rights: 'Hak cipta dilindungi undang-undang.',

  // Announcements
  announcement_withdrawal_delay_title: 'Penundaan Pemrosesan Penarikan',
  announcement_withdrawal_delay_summary: 'Penarikan dapat memakan waktu hingga 72 jam karena volume yang tinggi. Harap rencanakan dengan tepat.',
  announcement_date_june_14: '14 Juni 2025',

  // How It Works Steps
  step_1_title: 'Daftar',
  step_1_desc: 'Kurang dari 2 menit untuk membuat akun Anda.',
  step_1_detail_1: 'Masukkan informasi dasar Anda',
  step_1_detail_2: 'Verifikasi alamat email Anda',
  step_1_detail_3: 'Amankan akun Anda',
  step_1_detail_4: 'Akses instan ke dasbor',
  step_2_title: 'Pilih Tugas',
  step_2_desc: 'Pilih dari tugas promosi yang tersedia.',
  step_2_detail_1: 'Filter berdasarkan platform',
  step_2_detail_2: 'Lihat tingkat komisi',
  step_2_detail_3: 'Terima beberapa tugas',
  step_2_detail_4: 'Pembaruan tugas real-time',
  step_3_title: 'Selesaikan Tugas',
  step_3_desc: 'Selesaikan tugas sesuai instruksi.',
  step_3_detail_1: 'Instruksi yang mudah diikuti',
  step_3_detail_2: 'Pengiriman tugas yang cepat',
  step_3_detail_3: 'Verifikasi otomatis',
  step_3_detail_4: 'Antarmuka ramah seluler',
  step_4_title: 'Hasilkan & Tarik',
  step_4_desc: 'Dapatkan bayaran untuk setiap tugas yang selesai.',
  step_4_detail_1: 'Pelacakan penghasilan real-time',
  step_4_detail_2: 'Ambang penarikan sangat rendah',
  step_4_detail_3: 'Berbagai metode pembayaran',
  step_4_detail_4: 'Dukungan penarikan 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'Tetap Terhubung',
  footer_stay_loop_desc: 'Dapatkan update terbaru, tips & penawaran eksklusif langsung ke inbox Anda.',
  footer_subscribe: 'Berlangganan',
  footer_subscribe_placeholder: 'Masukkan alamat email Anda',
  footer_trusted_secure: 'TERPERCAYA & AMAN:',
  footer_ssl_secured: 'SSL Terjamin',
  footer_ssl_secured_desc: '256-bit SSL',
  footer_aes_encryption: 'Enkripsi AES-256',
  footer_aes_encryption_desc: 'Standar Bank',
  footer_kyc_compliant: 'Patuh KYC',
  footer_kyc_compliant_desc: 'Terverifikasi',
  footer_gdpr_compliant: 'Patuh GDPR',
  footer_gdpr_compliant_desc: 'Data Terlindungi',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Tersertifikasi',
  footer_platform: 'PLATFORM',
  footer_support: 'DUKUNGAN',
  footer_legal: 'HUKUM',
  footer_help_center: 'Pusat Bantuan',
  footer_contact_us: 'Hubungi Kami',
  footer_payments_label: 'Pembayaran:',
  home_live_activity_title: 'Aktivitas Platform Langsung',
  home_recent_activity_title: 'Aktivitas Terbaru',
  home_total_commissions_paid: 'Total Komisi yang Dibayarkan',
  home_active_users_online: 'Pengguna Aktif Online',
  home_tasks_completed_today: 'Tugas yang Diselesaikan Hari Ini',
  account_security_tips_title: 'Rekomendasi Keamanan',
  account_security_tips_desc: 'Tingkatkan perlindungan akun Anda dengan mengikuti praktik terbaik sederhana ini.',
  tip_password_title: 'Kata Sandi yang Kuat',
  tip_password_desc: 'Gunakan kombinasi huruf, angka, dan simbol untuk memastikan akun Anda tetap aman.',
  tip_two_factor_title: 'Verifikasi Identitas',
  tip_two_factor_desc: 'Selalu perbarui informasi kontak Anda untuk menerima pemberitahuan keamanan penting.',
  tip_logout_title: 'Logout Secara Teratur',
  tip_logout_desc: 'Selalu keluar dari akun Anda saat menggunakan komputer publik atau bersama.',
  tip_sharing_title: 'Jangan Pernah Bagikan Akses',
  tip_sharing_desc: 'Tim dukungan kami tidak akan pernah menanyakan kata sandi Anda. Jangan pernah bagikan kredensial Anda kepada siapa pun.',
};